import { type Component, type JSX } from 'solid-js'

export enum ButtonStyle {
  Primary,
  White
}

export interface ButtonProps {
  readonly style: ButtonStyle
  readonly action: (e: MouseEvent) => void
  readonly disabled?: boolean
  readonly width?: 'full' | 'fit'
  readonly class?: string
  readonly children?: JSX.Element
}

const Button: Component<ButtonProps> = (props) => {
  const getBtnClass = () => {
    switch (props.style) {
      case ButtonStyle.White:
        return 'btn--white'
      default:
        return 'btn--primary'
    }
  }

  const width = () => (props.width === 'full' ? 'w-full' : 'min-w-fit')
  const borderRadius = () => 'rounded-md'

  return (
    <button
      onClick={props.action}
      class={`btn ${getBtnClass()} ${width()} ${borderRadius()} ${props.class ?? ''}`}
      disabled={props.disabled}
    >
      {props.children}
    </button>
  )
}

export default Button
